/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type InternalDeliveryTransportMode =
  (typeof InternalDeliveryTransportMode)[keyof typeof InternalDeliveryTransportMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InternalDeliveryTransportMode = {
  OwnTruck: 1,
  ExternalTruckTransporter: 2,
  FieldTester: 3,
} as const;
